module.exports = __webpack_public_path__ + "static/0011-fbb676b5277fbdaef5816644867adb3b.png";